var _defs, _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectReceivable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.52 43.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M12.923 33.904s-.365.81.576 1.75l2.762 2.762c1.616 1.616 2.311.636 3.57-.623s2.239-1.955.623-3.57l-2.762-2.762c-.94-.94-1.75-.576-1.75-.576M12.859 27.884s.364-.809-.576-1.75l-2.762-2.762c-1.616-1.616-2.311-.636-3.569.622s-2.238 1.953-.622 3.569l2.762 2.762c.94.94 1.75.576 1.75.576"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.197 28.173l5.582 5.582M24.733 31.154h1.829l.665 2.997h3.49l.64-3.414s1.441-.651 2.597-1.68c1.129-1.005 1.724-2.647 1.724-2.647l3.721-1.367v-5.555l-3.52-1.233s-.504-2.836-2.232-4.801a18.632 18.632 0 00-.571-.623 11.821 11.821 0 00-1.787-1.552c-1.416-.983-3.049-1.549-5.407-1.846l-2.309 4.021 2.477 2.875-3.534 8.023-1.375-7.193-2.935-2.074 1.315-5.627c-2.697.448-4.073 1.191-5.334 2.07-1.197.835-3.605 3.139-4.486 5.925"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 30.739,
    cy: 18.536,
    r: 1.501
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectReceivable);
export default __webpack_public_path__ + "static/media/connectReceivable.4785b65e64f6b84f96c8a5df8664c932.svg";
export { ForwardRef as ReactComponent };